<template>
    <div class="is-actions">
        <form-button :form="form" :disabled="disabled" :class="'is-primary'">
            {{ submit }}
        </form-button>
        <transition name="fade">
            <span v-show="success" class="has-text-success">
                <fa-icon icon="check-circle" /> {{ savedText }}
            </span>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        form: { type: Object, required: true },
        submit: { type: String, required: true },
        reset: { type: Boolean, default: true },
        savedText: { type: String, default: 'Saved' },
        disabled: { type: Boolean, default: false },
    },

    data() {
        return {
            success: false,
        };
    },

    watch: {
        'form.successful'(val) {
            if (val) {
                if (this.reset) {
                    this.form.reset();
                }

                this.success = true;

                setTimeout(() => {
                    this.success = false;
                }, 1500);
            }
        },
    },
};
</script>

<style scoped>
.is-actions {
    display: flex;
    align-items: center;
}

.is-actions button {
    margin-right: 0.5rem;
}

.is-actions span {
    display: flex;
    align-items: center;
    position: relative;
}
</style>
